import React from 'react';

const TextAreaField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  error, 
  required = false,
  fullWidth = false,
  disabled = false,
  rows = 3
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`form-field ${fullWidth ? 'full-width' : ''}`}>
      <label className="field-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`field-textarea ${error ? 'error' : ''}`}
        disabled={disabled}
        required={required}
        rows={rows}
      />
      
      {error && (
        <div className="field-error">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}
    </div>
  );
};

export default TextAreaField;